import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'platform' })
export class CustomMenuOverlayContainer extends OverlayContainer {
  containerBox: HTMLElement | undefined;

  public myCreateContainer(element: HTMLElement): void {
    console.log(22);
    
    const container = document.createElement('div');
    element.appendChild(container);
    this._containerElement = container;
    this.containerBox = container;
  }

  public override _createContainer(): void {
    
    if (!this._containerElement) {
      const container = document.createElement('div');
      container.classList.add('cdk-overlay-container');
      // document.querySelector('.slider-menu-box')?.appendChild(container);
      document.body.appendChild(container);
      this._containerElement = container;
    }
  }
}